var map = {
	"./arrow-sm.svg": 4816,
	"./arrow.svg": 5719,
	"./dot.svg": 7688,
	"./home--m.svg": 6665,
	"./jemima-bg.svg": 8564,
	"./lionheart.svg": 6879,
	"./movielist/feelgood.svg": 4732,
	"./movielist/lionheart.svg": 5962,
	"./movielist/mwi.svg": 4459,
	"./movielist/nm.svg": 6835,
	"./movielist/rhi.svg": 9559,
	"./quam.svg": 9118,
	"./rhi.svg": 9244,
	"./shuga.svg": 9514
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 968;